module.exports = "#account label {\n  display: block;\n  margin-top: 20px;\n  margin-bottom: 5px;\n}\n#account button {\n  width: 100%;\n  margin-top: 10px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/account/language/language.component.less
// module id = 517
// module chunks = 0